/* ============================================================
   CART DRAWER + AJAX ADD — added 2026-08-20 (Sarah)

   Before this, every Add to Cart was a full page POST that dropped the
   customer on /cart, which is why quick add on a collection grid was not
   worth building: it would have interrupted the man at the exact moment
   he was assembling a basket.

   Progressive enhancement throughout. Everything here hangs off submit and
   click interception, so with JS off or broken the forms post normally and
   the customer lands on /cart exactly as before. Nothing below is required
   for the store to take an order.

   The drawer markup is re-rendered by Liquid through the Section Rendering
   API rather than patched in JS, so money formatting and the free-shipping
   calculation live in one place and cannot drift.
   ============================================================ */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastFocus = null;

  var drawer = function () { return document.querySelector('[data-cart-drawer]'); };

  /* The drawer is absent on the cart template by design, so every entry point
     below has to tolerate it not existing rather than assume it does. */
  function hasDrawer() { return !!drawer(); }

  function setBusy(on) {
    var d = drawer();
    if (d) d.setAttribute('data-busy', on ? '1' : '0');
  }

  function openDrawer() {
    var d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('on');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    var close = d.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('on');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  /* Re-render the drawer from Liquid. Returns a promise so callers can open
     only once the fresh contents are in place, rather than flashing the old
     cart for a frame. */
  function refresh() {
    var host = document.getElementById('shopify-section-' + SECTION_ID);
    if (!host) return Promise.resolve();
    return fetch(root + '?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;
        var wasOpen = host.querySelector('[data-cart-drawer]') &&
                      host.querySelector('[data-cart-drawer]').classList.contains('on');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#shopify-section-' + SECTION_ID) || tmp.firstElementChild;
        if (!fresh) return;
        host.replaceWith(fresh);
        /* Listeners are delegated on document, so replacing the node loses nothing. */
        if (wasOpen) {
          var d = drawer();
          if (d) {
            d.classList.add('on');
            d.setAttribute('aria-hidden', 'false');
          }
        }
      })
      .catch(function () { /* leave the old markup in place rather than blanking it */ });
  }

  /* The count lives in the header, which the section refresh does not touch. */
  function syncCount() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
        });
        return cart;
      })
      .catch(function () {});
  }

  function changeLine(line, qty) {
    setBusy(true);
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { return Promise.all([refresh(), syncCount()]); })
      .then(function () { setBusy(false); })
      .catch(function () { setBusy(false); window.location.href = root + 'cart'; });
  }

  /* ---- Add to cart, from the PDP form and from any quick-add card ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    /* No drawer on this template: let the browser post normally. */
    if (!hasDrawer()) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"], button[name="add"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) {
          /* Out of stock, or a variant that went unavailable between render and
             click. Say so on the button rather than failing silently. */
          if (btn) { btn.textContent = res.body.description || res.body.message || 'Unavailable'; }
          setTimeout(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
          }, 2600);
          return;
        }
        return Promise.all([refresh(), syncCount()]).then(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          openDrawer();
        });
      })
      .catch(function () {
        /* Network failure: fall back to the real form post rather than
           swallowing the customer's intent. */
        if (btn) { btn.disabled = false; btn.textContent = label; }
        form.submit();
      });
  });

  /* ---- Clicks: open, close, quantity, remove ---- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && hasDrawer()) {
      e.preventDefault();
      refresh().then(openDrawer);
      return;
    }

    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var qty = e.target.closest('[data-cd-qty]');
    if (qty) {
      var row = qty.closest('[data-cd-line]');
      var input = row && row.querySelector('[data-cd-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      v += qty.getAttribute('data-cd-qty') === 'up' ? 1 : -1;
      if (v < 0) v = 0;
      changeLine(parseInt(qty.getAttribute('data-line'), 10), v);
      return;
    }

    var rm = e.target.closest('[data-cd-remove]');
    if (rm) {
      changeLine(parseInt(rm.getAttribute('data-line'), 10), 0);
      return;
    }

    /* PDP quantity. Deliberately separate from the cart's [data-qty-change]
       handler above, which submits its form on every click. */
    var pq = e.target.closest('[data-pdp-qty]');
    if (pq) {
      var pin = document.querySelector('[data-pdp-qty-input]');
      if (!pin) return;
      var pv = parseInt(pin.value, 10) || 1;
      pv += pq.getAttribute('data-pdp-qty') === 'up' ? 1 : -1;
      pin.value = Math.max(pv, 1);
    }
  });

  /* Typing straight into the drawer quantity field. */
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cd-qty-input]');
    if (!input) return;
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    changeLine(parseInt(input.getAttribute('data-line'), 10), v);
  });

  /* ---- Search panel ----
     The search template shipped with the original theme and nothing linked to it.
     The header link has a real href, so this is an upgrade rather than a dependency:
     with JS off the link goes to /search and the page works as built. */
  function searchPanel() { return document.querySelector('[data-search-panel]'); }

  function openSearch() {
    var p = searchPanel();
    if (!p) return;
    p.hidden = false;
    document.querySelectorAll('[data-search-open]').forEach(function (a) {
      a.setAttribute('aria-expanded', 'true');
    });
    var input = p.querySelector('[data-search-input]');
    if (input) input.focus();
  }

  function closeSearch() {
    var p = searchPanel();
    if (!p) return;
    p.hidden = true;
    document.querySelectorAll('[data-search-open]').forEach(function (a) {
      a.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-search-open]');
    if (open && searchPanel()) {
      e.preventDefault();
      var p = searchPanel();
      if (p.hidden) { openSearch(); } else { closeSearch(); }
      return;
    }
    if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      closeSearch();
    }
  });

  /* Never submit an empty query: Shopify renders a bare results page for it,
     which reads as "no results" rather than "you typed nothing". */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('nsearchform')) return;
    var input = form.querySelector('[data-search-input]');
    if (input && input.value.trim() === '') {
      e.preventDefault();
      input.focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = drawer();
    if (d && d.classList.contains('on')) { closeDrawer(); return; }
    var p = searchPanel();
    if (p && !p.hidden) closeSearch();
  });

})();